import * as Forms from '@rushplay/forms'
import * as I18n from '@rushplay/i18n'
import * as React from 'react'
import * as ThemeUi from 'theme-ui'

import {FieldResponse} from './field-response'
import {getNormalizedTranslationKey} from './get-normalized-translation-key'
import {isFieldRequired} from './is-field-required'

const SCOPE = '#/definitions/PiqBestpaytransferWithdrawal/properties/branchCode'

// Branch list provided by Bestpaytransfer, options are displayed as-is (not
// translated) while `code` is the value sent to the payment provider.
const OPTIONS = [
  {label: '本店営業部 (honten) - 001', code: '001:本店営業部'},
  {label: 'すずめ (suzume) – 002', code: '002:すずめ'},
  {label: 'はやぶさ (hayabusa) – 003', code: '003:はやぶさ'},
  {label: 'ふくろう (fukurou) – 004', code: '004:ふくろう'},
  {label: 'ビジネス営業部 (bijinesu) – 005', code: '005:ビジネス営業部'},
  {label: 'つばめ (tsubame) – 006', code: '006:つばめ'},
  {label: 'かわせみ (kawasemi) – 007', code: '007:かわせみ'},
  {label: 'うぐいす (uguisu) – 008', code: '008:うぐいす'},
  {label: 'とき (toki) – 009', code: '009:とき'},
  {label: 'ＬＩＮＥ (line) – 010', code: '010:ＬＩＮＥ'},
  {label: 'フラミンゴ (furamingo) – 601', code: '601:フラミンゴ'},
  {label: 'ペンギン (pengin) – 602', code: '602:ペンギン'},
  {label: 'カエデ (kaede) – 701', code: '701:カエデ'},
  {label: 'モミジ (momiji) – 702', code: '702:モミジ'},
  {label: 'サクラ (sakura) – 703', code: '703:サクラ'},
  {label: 'ウメ (ume) – 704', code: '704:ウメ'},
  {label: 'ツバキ (tsubaki) – 705', code: '705:ツバキ'},
  {label: 'ケヤキ (keyaki) – 706', code: '706:ケヤキ'},
  {label: 'クスノキ (kusunoki) – 707', code: '707:クスノキ'},
  {label: 'ヒイラギ (hiiragi) – 708', code: '708:ヒイラギ'},
  {label: 'シラカバ (shirakaba) – 709', code: '709:シラカバ'},
  {label: 'ツツジ (tsutsuji) – 710', code: '710:ツツジ'},
  {label: 'おひつじ座 (ohitsujiza) – 801', code: '801:おひつじ座'},
  {label: 'おうし座 (oushiza) – 802', code: '802:おうし座'},
  {label: 'ふたご座 (futagoza) – 803', code: '803:ふたご座'},
  {label: 'ラインブラウン (raimburaun) – 804', code: '804:ラインブラウン'},
  {label: 'ラインコニー (rainkoni-) – 805', code: '805:ラインコニー'},
  {label: 'おとめ座 (otomeza) – 806', code: '806:おとめ座'},
  {label: 'てんびん座 (tembinza) – 807', code: '807:てんびん座'},
  {label: 'さそり座 (sasoriza) – 808', code: '808:さそり座'},
  {label: 'へびつかい座 (hebitsukaiza) – 809', code: '809:へびつかい座'},
  {
    label: 'ソフトバンクカード (sofutobankuka-do) – 810',
    code: '810:ソフトバンクカード',
  },
  {label: 'やぎ座 (yagiza) – 811', code: '811:やぎ座'},
  {label: 'みずがめ座 (mizugameza) – 812', code: '812:みずがめ座'},
  {label: 'うお座 (uoza) – 813', code: '813:うお座'},
  {
    label: 'ＰａｙＰａｙカード (paypayka-do) – 814',
    code: '814:ＰａｙＰａｙカード',
  },
  {
    label: 'ＰａｙＰａｙカード第二 (paypayka-dodaini) – 815',
    code: '815:ＰａｙＰａｙカード第二',
  },
  {label: 'アンドロメダ座 (andoromedaza) – 816', code: '816:アンドロメダ座'},
  {label: 'スペード (supe-do) – 817', code: '817:スペード'},
  {label: 'ハート (ha-to) – 818', code: '818:ハート'},
  {label: 'アイスクリーム (aisukuri-mu) – 819', code: '819:アイスクリーム'},
  {label: 'カステラ (kasutera) – 820', code: '820:カステラ'},
  {label: 'いるか座 (irukaza) – 821', code: '821:いるか座'},
  {label: 'うさぎ座 (usagiza) – 822', code: '822:うさぎ座'},
  {label: 'うしかい座 (ushikaiza) – 823', code: '823:うしかい座'},
  {label: 'おおかみ座 (ookamiza) – 824', code: '824:おおかみ座'},
  {label: 'オリオン座 (orionza) – 825', code: '825:オリオン座'},
  {label: 'カシオペヤ座 (kashiopeyaza) – 826', code: '826:カシオペヤ座'},
  {label: 'きりん座 (kirinza) – 827', code: '827:きりん座'},
  {label: 'クジラ座 (kujiraza) – 828', code: 'クジラ座 (kujiraza) – 828'},
  {
    label: 'ケンタウルス座 (kentaurusuza) – 829',
    code: 'ケンタウルス座 (kentaurusuza) – 829',
  },
  {label: 'こいぬ座 (koinuza) – 830', code: '830:こいぬ座'},
  {label: 'さんかく座 (sankakuza) – 831', code: '831:さんかく座'},
  {label: 'じょうぎ座 (jiyougiza) – 832', code: '832:じょうぎ座'},
  {label: 'たて座 (tateza) – 833', code: '833:たて座'},
  {label: 'つる座 (tsuruza) – 834', code: '834:つる座'},
  {label: 'とけい座 (tokeiza) – 835', code: '835:とけい座'},
  {label: 'とびうお座 (tobiuoza) – 836', code: '836:とびうお座'},
  {label: 'はと座 (hatoza) – 837', code: '837:はと座'},
  {label: 'ペガスス座 (pegasusuza) – 838', code: '838:ペガスス座'},
  {label: 'ポンプ座 (pompuza) – 839', code: '839:ポンプ座'},
  {label: 'やまねこ座 (yamanekoza) – 840', code: '840:やまねこ座'},
]

/**
 * Component that renders a Select with the available Bestpaytransfer branch
 * codes. Option labels are displayed as provided (not translated), while
 * `code` is the value sent to Bestpaytransfer.
 * @component BestpaytransferBranchCodeSelect
 * @returns {ReactNode}
 */
export function BestpaytransferBranchCodeSelect() {
  const field = Forms.useField(SCOPE, {initialValue: OPTIONS[0].code})
  const paymentMethodId = Forms.useField('#/properties/provider', {
    noRegister: true,
  }).value

  const labelKey = getNormalizedTranslationKey(field.label, paymentMethodId)
  const placeholderKey = getNormalizedTranslationKey(
    field.placeholder,
    paymentMethodId
  )
  const schema = Forms.useFormSchema()
  const {theme} = ThemeUi.useThemeUI()
  const required =
    theme.colors?.requiredMarkColor && isFieldRequired(schema, SCOPE)

  const translate = I18n.useTranslate(() => [labelKey, placeholderKey])

  const value = field.value && field.value.toString()

  return (
    <ThemeUi.Grid>
      <ThemeUi.Field
        as={ThemeUi.Select}
        label={
          <>
            {translate(labelKey)}
            {required && (
              <ThemeUi.Text
                as="span"
                sx={{color: 'requiredMarkColor', ml: '4px'}}
              >
                *
              </ThemeUi.Text>
            )}
          </>
        }
        name={field.name}
        placeholder={translate(placeholderKey)}
        value={value}
        onChange={field.onChange}
        onBlur={field.onBlur}
      >
        {OPTIONS.map((option) => (
          <option key={option.code} value={option.code}>
            {option.label}
          </option>
        ))}
      </ThemeUi.Field>
      <FieldResponse scope={SCOPE} />
    </ThemeUi.Grid>
  )
}
